import { render } from "./builder.vue?vue&type=template&id=14575a90"
import script from "./builder.vue?vue&type=script&lang=js"
export * from "./builder.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/builder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14575a90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14575a90', __exports__)) {
    api.reload('14575a90', __exports__)
  }
  
  module.hot.accept("./builder.vue?vue&type=template&id=14575a90", () => {
    api.rerender('14575a90', render)
  })

}


export default __exports__